// extracted by mini-css-extract-plugin
module.exports = {"modal-card-head":"NewModal_modal-card-head__2kM74","footer":"NewModal_footer__2L-96","content-without-header":"NewModal_content-without-header__1Rkrb"};